module.exports = __webpack_public_path__ + "img/activity62.a3a113f0.png";